import { render, staticRenderFns } from "./TestPush.vue?vue&type=template&id=208b6987&"
import script from "./TestPush.vue?vue&type=script&lang=ts&"
export * from "./TestPush.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports